import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    AccountInfoFragment,
    GetAccountInfo as GetAccountInfoQuery,
} from 'nutshell-graphql-types';

import GET_ACCOUNT_INFO from './graphql/queries/get-account-info.graphql';

export const useGetAccountInfo = (
    accountId: string
): {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    accountInfo: AccountInfoFragment | null | undefined;
} => {
    const {
        data,
        loading: isLoading,
        error,
    } = useQuery<GetAccountInfoQuery, Record<any, any>>(GET_ACCOUNT_INFO, {
        variables: {
            id: accountId,
        },
    });

    return {
        accountInfo: data && data.account ? data.account : undefined,
        isLoading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
};
